import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportRequisicaoCompraUseCase } from "../../../presentation/useCases/read/get_report_requisicao_compra_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportRequisicaoCompraUseCase
 */

export class GetReportRequisicaoCompraUseCase implements IGetReportRequisicaoCompraUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportRequisicaoCompra(
    idRequisicaoCompra: number,
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportRequisicaoCompra(
      requiredMimeType,
      idRequisicaoCompra,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `requisicao_compra_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
